
export const routes = {
  HomePage: "/",
  AboutUs: "/about",
  Engineering_Mechanics: "/engineering_mechanics",
  Thermodynamics: "/thermodynamics",
  HeatnMassTransfer: "/heat_mass_transfer",
  KeamNavigator: "/keam-navigator",

};
